<template>
    <footer :class="{'slideDown' : scrolling, 'fixed' : move}" ref="footer">
        <button type="button" v-if="main">홈</button>
        <button type="button" @click="goPage('/myCstmr/myCstmrList')">내 고객</button>
        <button type="button" @click="goPage('/myCstmr/myCstmrReg')">고객등록</button>
        <button type="button" @click="goPage('/eduplanmap')">에듀플랜맵</button>
        <button type="button" @click="goPage('/mypage/myEduInfor')">내 활동</button>
    </footer>
</template>

<script>
export default {
    props: {
        main : Boolean,
    },
    data() {
      return {
        move: false,
        scrolling: false,
        bodyH: 0,
      }
    },
    created: function() {
        let isScrolling;
        window.addEventListener('scroll', () => {
            this.scrolling = true
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(() => {
                this.scrolling = false
            }, 400);
        }, false);
        window.addEventListener('scroll', this.moveScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.moveScroll);
    },
    methods: {
        moveScroll () {
            this.bodyH = this.$parent.$refs.body.clientHeight - this.$refs.footer.clientHeight - window.innerHeight;
            this.isUserScrolling = (window.scrollY <= this.bodyH - 1);
            if(this.isUserScrolling){
                this.move = false
            }else{
                this.move = true
            }
        },
        goPage(url){
            this.$router.push(url).catch(function() {}).then((() =>window.scrollTo(0,0) ));
        }
    },
};
</script>